/** CTA button placeholder, sized to the design system's default height. */

import { BaseSkeleton } from './base-skeleton';

export type ButtonSkeletonProps = { width?: number | string };

export function ButtonSkeleton({ width = 160 }: ButtonSkeletonProps) {
    return <BaseSkeleton borderRadius={20} height={40} width={width} />;
}
